import React, { useState } from "react";
import { Formik, Form, Field, ErrorMessage } from 'formik';
import axios from "axios";
import { Link } from "react-router-dom";
import { message } from 'antd';
import { useNavigate } from 'react-router-dom';
import { AUTH_URL } from '../../../src/configs/AppConfig';

const success = () => {
  message.success('Your sign up is done');
};


export default function SignUp() {
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate()
  function handleRedirct() {
    navigate('/admin/');
  }

  return (
    <>
     <div className="animation-img">
       </div>
    <div className="flex items-center justify-center px-2 md:mx-0 md:px-0 lg:mb-10 lg:items-center lg:justify-start login-inputs">
      {/* Sign up section */}
      <div className="w-full max-w-full flex-col items-center md:pl-4 lg:pl-0 ">
        <h4 className="login-text">
          SIGN UP
        </h4>
        <p className="details-text">
          Please fill the form below to sign up!
        </p>
        <div>

     <Formik
       initialValues={{ userName: '', password: '', email: '' }}
            validate={values => {
              const errors = {};
              if (!values.userName) {
                errors.userName = 'Username is required';
              }
              else if (!values.email) {
                errors.email = 'Email is required';
              }
              else if (!values.password) {
                errors.password = 'Password is required';
              }
              else if (
                !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
              ) {
                errors.email = 'Invalid email address';
              }
              else if (!values.confirmPassword) {
                errors.confirmPassword = 'Confirm Password required';
              }
              else if (values.password !== values.confirmPassword) {
                errors.confirmPassword = "Password doesn't not match";
              }
        //  else if (
        //    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i.test(values.email)
        //  ) {
        //    errors.email = 'Invalid email address';
        //  }
         return errors;
       }}
       onSubmit={(values ,{setSubmitting}) => {
        setIsLoading(true);
       axios.post(`${AUTH_URL}users`, {
          userName: values.userName.trim(),
          password: values.password.trim(),
          email: values.email.trim()
        })
        .then(function (response) {
          success()
          const token = response?.data.access_token
          localStorage.setItem('token', token);
          setIsLoading(false);
          handleRedirct()
          
        })
        .catch(function (error) {
          message.error(error?.response?.data?.message || 'This is email or username exist before');
          setIsLoading(false);
        });
         }
      }
     >
       {({ isSubmitting }) => (
         <Form>
           <Field type="text" placeholder="Username" name="userName" id="userName" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`}/>
           <ErrorMessage name="userName" component="div" id="erroMassage" />
            <Field type="email" placeholder="Email" name="email" id="email" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`} />
           <ErrorMessage name="email" component="div" id="erroMassage" />     
           <Field type="password" placeholder="Password" name="password" id="password" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`} />
           <ErrorMessage name="password" component="div" id="erroMassage" /> 
           <Field type="password" placeholder="Confirm password" name="confirmPassword" id="confirmPassword" className={`flex h-12 w-full items-center justify-center border bg-white/0 p-3 outline-none inputs-css`} />
           <ErrorMessage name="confirmPassword" component="div" id="erroMassage" />   
                             
           <button type="submit" disabled={isLoading} className="linear w-full py-[12px] text-base transition duration-200 hover:bg-brand-600 active:bg-brand-700 login-btn">
           Sign Up
           </button>
         </Form>
       )}
     </Formik>
   </div>
    <div className="mt-4">
          <span className=" text-sm font-medium text-navy-700 dark:text-gray-600">
            You have an account?
          </span>
          <Link to="/auth/sign-in" className="ml-1 text-sm font-medium text-brand-500 hover:text-brand-600 dark:text-white">Sign in</Link>
        </div>

      </div>
    </div></>
  );
}
